// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // api_code: '?code=vZzsGEVnVwFgImcTLUQF61IkOyYItK6qf9Km1g4fO641AzFuT17bTQ==',
    api_code: '',
    api_host: 'https://adams-search.nrc.gov/',
    results_max: 50000,
    download_worker_host: 'https://adams-search.nrc.gov/',
    download_files_max: 25,
    site_name: 'ADAMS Public Search',
    devPortalUrl: 'https://adams-api-developer.nrc.gov'
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  